import React, { Component } from 'react';
import Loading from 'bee-loading';
require('bee-loading/build/Loading.css');
//import AjaxLoading from "./AjaxLoading";

require('./loading.less');
export default class NCLoading extends Component {
	render() {
		const { wrapperClassName, ajaxLoading, ...others } = this.props;
		// if (ajaxLoading) {
		// 	return <AjaxLoading {...others} />
		// }
		return (
			<Loading
				wrapperClassName={wrapperClassName ? wrapperClassName + ' nc-loading' : 'nc-loading'}
				{...others}
			/>
		);
	}
}
